import { createFeatureSelector } from '@ngrx/store';

export const onlineMenuFiltersState = createFeatureSelector<OLO.State, OLO.State.OnlineMenuFilters>('onlineMenuFilters');
